// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Currency: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <path
                fill="currentColor"
                fillOpacity=".66"
                d="M7,0 C3.13359392,0 0,3.13359392 0,7 C0,10.8664061 3.13359392,14 7,14 C10.8664061,14 14,10.8664061 14,7 C14,3.13359392 10.8664061,0 7,0 Z M9.37343717,8.59414029 C9.22753096,9.37097633 8.57937443,9.88285136 7.65843713,10.0305074 L7.65843713,10.5 C7.65843713,10.8623047 7.36449182,11.15625 7.00218713,11.15625 C6.63988245,11.15625 6.34593713,10.8623047 6.34593713,10.5 L6.34593713,10.0061719 C5.9601168,9.93942559 5.56664026,9.81594145 5.21554661,9.69882846 L5.04634339,9.64285588 C4.70208567,9.52962565 4.51396054,9.15914488 4.62689036,8.81488717 C4.73924565,8.47008288 5.10841382,8.28305089 5.45485908,8.39543414 L5.63046056,8.45353961 C5.96186668,8.56419969 6.33839023,8.68937945 6.64436686,8.73217249 C7.4037025,8.84026241 8.02194512,8.67792225 8.08346856,8.35182083 C8.1326052,8.08907449 8.0334841,7.95068765 6.83167171,7.63322711 L6.59531242,7.57148421 C5.91937488,7.38776171 4.33589864,6.95843738 4.62656242,5.40695286 C4.77296096,4.62929654 5.422539,4.1187892 6.34484357,3.97140598 L6.34484357,3.5 C6.34484357,3.13769531 6.63878888,2.84375 7.00109315,2.84375 C7.36339784,2.84375 7.65734315,3.13769531 7.65734315,3.5 L7.65734315,3.96757829 C7.9026984,4.01039886 8.17331958,4.0765152 8.51128876,4.1846602 C8.85636675,4.29488301 9.04695272,4.6639961 8.93675745,5.0093478 C8.82738245,5.35497278 8.45824182,5.54719931 8.11206985,5.43481648 C7.79679644,5.33441031 7.54824185,5.2716018 7.35164022,5.24297214 C6.59667927,5.13616729 5.97761679,5.29766005 5.91664034,5.6235975 C5.88164079,5.84062517 5.84882796,6.00742179 6.93984383,6.30273438 L7.16627717,6.36297274 C8.10195279,6.61171883 9.66601562,7.02460921 9.37343717,8.59414029 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default React.memo(Currency);
